// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'   // 状态管理
import router from './router'
import '@/js/iconfont.js' //

import './permission' // permission control

import * as filters from './filters' // global filters

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

Vue.config.ignoredElements = [
  'wx-open-launch-weapp',
]

import VueClipboards from 'vue-clipboard2'
Vue.use(VueClipboards)


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js